export default {
    state: {
        articles: [],
        worksheets: [],
        related_media: [],
        explore_more: [],
        questions: []
    },
    mutations: {
        setArticles (state, payload) {
            state.articles = payload
        },
        setArticleRelatedMedia (state, payload) {
            state.related_media = payload
        },
        setArticleExploreMore (state, payload) {
            state.explore_more = payload
        }
    },
    actions: {
        getArticles (context, article_id) {
            return new Promise((resolve, reject) => {
                if (article_id) {
                    this._vm.axios.get('/api/articles/' + article_id)
                    .then(response => {
                        let articles = []

                        if (response.data) {
                            articles = _.orderBy(response.data, 'order_number')
                        }

                        context.commit('setArticles', articles)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
                } else {
                    this._vm.axios.get('/api/articles')
                    .then(response => {
                        let articles = []

                        if (response.data) {
                            articles = _.orderBy(response.data, 'order_number')
                        }

                        context.commit('setArticles', articles)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
                }
            })
        },
        deleteRelatedMediaQuestion (context, question_id) {
            return new Promise((resolve, reject) => {
                this._vm.axios.post('/api/articles/delete_explore_more_question/' + question_id)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
            })
        }
    }
}
